import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { Markup } from "interweave";
import axios from "axios";
import LearningSessionResultTable from "../../../Components/Admin/Home/Pages/AdminLearningSession/AdminLearningMain/LearningSessionResultTable";
import Nodata from "../../../Components/Reuseable/Nodata";
import { serverInfo } from "../../../App";
import { useContext } from "react";

const LearningSessionResult = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data } = props;
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const [showTable, setShowTable] = useState(false);
  const [showResult, setShowResult] = useState(null);

  const resultData = (eventId) => {
    axios
      .get(`/api/star/learning_session/showResult/${eventId}`)
      .then((res) => {
        if (res.status === 200) {
          setShowResult(res.data.events);
        }
      });
  };

  const tableHead = ["Serial", "Name", "Email", "Mark"];

  return (
    <>
      {currentItems.length === 0 ? (
        <></>
      ) : (
        <>
          <div className="row ">
            {currentItems.map((event_data) => {
              return (
                <>
                  <div
                    onClick={() => resultData(event_data.id)}
                    className="col-sm-12 col-md-6 col-lg-3 mb-3  card-bg"
                    style={{ cursor: "pointer" }}
                  >
                    {event_data.banner ? (
                      <>
                        <div>
                          <img
                            src={imageCdnUrl + event_data.banner}
                            className="img-fluid image-hover-link"
                            alt=""
                            style={{
                              height: "200px",
                              width: "100%",
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <ReactPlayer
                          url={videoCdnUrl + event_data.video}
                          controls={true}
                          volume={1}
                          width="100%"
                          height="200px"
                          style={{ margin: "0 auto" }}
                        />
                      </>
                    )}
                    <div>
                      <div className="p-3">
                        <div className="under-line-warning my-2"></div>
                        <div className="d-flex justify-content-between">
                          <h6 className="text-white text-ellipsis Title_Link">
                            {event_data.title}
                          </h6>
                        </div>
                        <p className="text-secondary limit-text-result">
                          <Markup content={event_data?.description}></Markup>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>

          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>

          {showResult ? (
            <LearningSessionResultTable
              tableHead={tableHead}
              data={showResult}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default LearningSessionResult;
